import { put } from 'redux-saga/effects'
import importer from 'common/importer'
import TagManager from 'react-gtm-module'

const UserActions = importer('Stores/Users/Actions')
export default function * success ({ res }) {
  TagManager.dataLayer({
    dataLayer: {
      event: 'signIn',
      userId: res?._embedded?.user?.profile?.login
    }
  })
  const { sessionToken } = res
  yield put(UserActions.loginAuth({ sessionToken }))
}
